import { TranscriptionConfig } from './types'

export const DEFAULT_TRANSCRIPTION_CONFIG: TranscriptionConfig = {
  // Basic
  resolution: 64,
  bpm: null,
  smartSounds: true,
  unifiedSelector: true,
  humanize: true,
  detectChords: true,
  swing: true,
  electronic: false,
  quantize: 0,
  duration: true,
  merge: true,

  // Drums
  larsnet: true,
  onsetFilter: 0.7,
  onsetKick: null,
  onsetSnare: null,
  onsetHihat: null,
  velocity: true,
  soundMatch: true,
  enhanced: true,
  logLevel: 1,
  explain: false,

  // Melody
  melodyMode: 'none',
  melodyRegister: 'lead',
  minConfidence: null,
  crepe: 'auto',
  splitBass: true,
  clean: false,
  noMerge: false,
  splitStems: false,
  splitThreshold: 0.35,

  // Advanced
  v9: true,
  humanFeel: true,
  textHint: null,
  trackName: null,
  artist: null,
  parseBpm: true,
  noConfidence: false,
  logFile: null,
}
